import React, { Fragment } from "react"
import { ThemeProvider } from "styled-components"
import { mainTheme } from "../theme"

import SEO from "../components/seo"

import Sticky from "react-stickynode"
import { ResetCSS } from "../assets/css/style"
import { GlobalStyle, ContentWrapper } from "../theme/global.style"
import { DrawerProvider } from "../contexts/DrawerContext"
import Navbar from "../components/Navbar"
import Banner from "../components/BannerSection"
import FeatureSection from "../components/Features"
import LatestNewsSection from "../components/LatestNews"
import ProductSlide from "../components/ProductSlide"
// import BetaSections from "../components/BetaSection"
import Footer from "../components/Footer"

const IndexPage = () => (
  <ThemeProvider theme={mainTheme}>
    <Fragment>
      <SEO title="Appidev | Digital agency in web and mobile development" />
      <ResetCSS />
      <GlobalStyle />
      <ContentWrapper>
        <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
          <DrawerProvider>
            <Navbar />
          </DrawerProvider>
        </Sticky>
        <Banner />
        <FeatureSection />
        <LatestNewsSection />
        <ProductSlide />
        {/* <BetaSections /> */}
        <Footer />
        {/* {/* <h1>Hi people</h1> */}
        {/* <p>Welcome to your new Gatsby site.</p> */}

        {/* <Link to="/page-2/">Go to page 2</Link> */}
      </ContentWrapper>
    </Fragment>
  </ThemeProvider>
)

export default IndexPage
